import React, { useRef } from 'react';
import ClientsTable from './ClientsTable';
import { ClientsUIProvider } from './ClientsUIContext';
import ClientsHeader from './ClientsHeader';
import ClientFilters from './ClientsFilters';
import { Card } from '../../../components';
import { Box } from '@mui/material';

export default function Clients () {
    const clientFiltersRef = useRef();

    const resetFilters = () => {
        if (clientFiltersRef.current) {
            clientFiltersRef.current.reset();
        }
    };
    const getSearch = () => {
        if (clientFiltersRef.current) {
            return clientFiltersRef.current.search;
        }
    };

    return (
        <ClientsUIProvider>
            <Box display='flex' flexDirection='column' justifyContent='center' className='pageContainerFluid--standalone'>
                <Box style={{ borderRadius: '0.308rem' }}>
                    <Card>
                        <ClientsHeader />
                    </Card>
                </Box>
                <Card >
                    <Box style={{ height: '70', padding: '16px 0', borderRadius: '4px', margin: '0 -10px' }}>
                        <ClientFilters
                            ref={clientFiltersRef}
                        />
                    </Box>
                </Card>
                <ClientsTable resetFilters={resetFilters} getSearch={getSearch} />
            </Box>
        </ClientsUIProvider>
    );
}
